import React, { useState, useEffect } from "react";
import BreadcrumbComponent from "../../components/BreadCrumb";
import MetaTags from "react-meta-tags";
import moment from "moment/moment";
import { toast } from "react-toastify";
import api from "../../helpers";
import dayjs from "dayjs"
import {Row, Col, Button, Modal, Typography, Input, Select, DatePicker, Space, Table, Form} from "antd"
import {
  PlusCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import * as phaseAction from "../../store/Project/action";
import * as employeeAction from '../../store/Employee/actions'
import { useDispatch, useSelector } from "react-redux";

const Phase = ()=>{
    const [modalVisible, setmodalVisible] = useState(false)
    const [isEdit, setIsEdit] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchLoading, setSearchLoading] = useState(false);
    const employeeDropdown = useSelector((ss)=>ss.Employee);
    const updatedget = useSelector((ph)=>ph.Project)
    console.log("updatedget",updatedget);
    const {phaselist} = updatedget;
    const [phaseId, setPhaseId] = useState();
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
      const [employeeName, setemployeeName] = useState([]);
    const [from] = Form.useForm();
    const [disabled, setDisabled] = useState(false)
    const [searchValue, setSearchValue] = useState({
            limit: 10,
            page: 1,
          });
    const [searchInput, setSearchInput] = useState("");
    const [fields, setFields] = useState([]);
    const BCrumb = [
    { to: "/", title: "Home" },
    { title: "Phase" },
  ];

  const [totalCount,setTotalCount] = useState(phaselist.total);
      console.log(phaselist.total,"count")
      useEffect(() => {
          if (phaselist) {
            setTotalCount(phaselist?.total);
          }
        }, [phaselist]);

  const employeeOption = employeeDropdown.employee_list?.data  &&  employeeDropdown.employee_list?.data.length > 0 ?  employeeDropdown.employee_list?.data.map((data)=>{
    return{
      label :data.employeeName,
      value:  data._id,
    }
  }) : []

    console.log(updatedget,"updatedget")
    console.log(updatedget.phaselist,"updatedget")

    const specificDispatch = useDispatch();
    const dispatch = useDispatch();

     useEffect(()=>{
       specificDispatch(phaseAction.loadPhaseDetails({
         limit:10,
         page:1,
         status:"BOTH",
       }))
       specificDispatch(phaseAction.loadDropdownProject());
       specificDispatch(phaseAction.loadProjectDetails());
       specificDispatch(employeeAction.loadEmployee());
     },[specificDispatch]);


     const [phaseDetails, setPhaseDetails] = useState({
         projectId: "",
         phase:"",
         startDate: "",
         endDate: "",
         developers:[],
         phaseBudget:"",
         phaseStatus:"",
         milestones: "",
         externalLink:[],
       });

     const clearModelData = () => {
    from.resetFields()
    setPhaseDetails({
      projectId: "",
      phase:"",
      startDate: "",
      endDate: "",
      developers:[],
      phaseBudget:"",
      phaseStatus:"",
      milestones: "",
      externalLink:[],
    });
  };

//     useEffect(() => {
//   if (phaselist && phaselist.length > 0) {
//     console.log("Phases from API:", phaselist);
//   }
// }, [phaselist]);

const projectOptions =  updatedget.projectlist.projects && updatedget.projectlist.projects.length > 0 ? updatedget.projectlist.projects.map((pro)=>({
  label:`${pro.projectCode}-${pro.projectName}`,
  value:pro._id
})):[]

  const tableData =
      updatedget.phaselist.phases
        ? updatedget.phaselist.phases.map((data, index) => {
          const statusOption = updatedget.dropdownlist.projectStatusOptions.find(
          (option) => option.value === data.phaseStatus
        );
         const project =
          data.projectId && data.projectId._id
            ? updatedget.projectlist.projects.find((proj) => proj._id === data.projectId._id)
            : null;
            return {
              _id: data._id,
              sno: index + 1,
              projectId: project? `${project.projectCode}-${project.projectName}`:"",
              phase: data.phase,
              startDate: moment(data.startDate).format("DD/MM/YYYY") || "--",
              endDate: moment.utc(data.endDate).format("DD/MM/YYYY") || "--",
              developers:data.developers,
              phaseBudget:data.phaseBudget,
              phaseStatus: statusOption?statusOption.label:"-",
              // attachment: data.attachment || "",
              milestones:data.milestones,
              editData: data,
            };
          })
        : []


  const showModalOpen = ()=>{
    clearModelData();
     setmodalVisible(true)
  }
  const handleModalClose = () => {
    setmodalVisible(false);
  };

   const handleDeleteModalCancel = () => {
      setDeleteModalOpen(false);
    };

  useEffect(() => {
    setPhaseDetails((prev) => ({
      ...prev,
      developers: employeeName,
    }));
  }, [employeeName]);

  const handleSearch = () => {
      const payload = {
        search: searchInput,
        status: "BOTH",
      };
      setSearchLoading(true);
  
      setTimeout(() => {
        setSearchLoading(false);
      }, 500);
      setSearchValue(payload);
      dispatch(phaseAction.loadPhaseDetails(payload));
    };

  const handleRemoveField = (index) => {
  const newFields = [...fields];
  newFields.splice(index, 1);
  setFields(newFields);
  };

  const handleAddField = () => {
    setFields([...fields, { label: "", value: "" }]);
  };

    const handleChange = (index, key, e) => {
    const newFields = [...fields];
    newFields[index][key] = e.target.value;
    setFields(newFields);
  };

   const handleModalChange = (e) => {
    const { name, value } = e.target;

    setPhaseDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const downloadFile = ({ data, fileName, fileType }) => {
      const blob = new Blob([data], { type: fileType });
  
      const a = document.createElement("a");
      a.download = fileName;
      a.href = window.URL.createObjectURL(blob);
      const clickEvt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      a.dispatchEvent(clickEvt);
      a.remove();
    };
  
      const exportToCsv = async () => {
            let searchFilter = {};
        
            if (phaseDetails.startDate)
              searchFilter.startDate = moment(
                phaseDetails.startDate
              ).format("DD-MM-YYYY");
            if (phaseDetails.endDate)
              searchFilter.endDate = moment(phaseDetails.endDate).format(
                "DD-MM-YYYY"
              );
          setDownloadLoader(true);
          try {
            const res = await api.post("/auth/employee/getphase", searchFilter);
            const phase = res.data?.phases || [];
      
            const mappedData = phase.map((data, index) => ({
              _id: data._id,
              sno: index + 1,
              phase: data.phase || "--",
              startDate: data.startDate
                ? moment(data.startDate).format("DD/MM/YYYY")
                : "--",
              endDate: data.endDate ? moment(data.endDate).format("DD/MM/YYYY") : "--",
              phaseStatus: data.phaseStatus,
              phaseBudget:data.phaseBudget,
              developers:data.developers || "--",
              milestones:data.milestones,
              editData: data,
            }));
      
            const headers = [
              "s.no",
              "phase",
              "starDate",
              "endDate",
              "phaseStatus",
              "phaseBudget",
              "Developers",
              "milestones",
            ];
      
            const csvRows = mappedData.map((item) => [
            item.sno,
            item.phase,
            item.startDate,
            item.endDate,
            item.phaseStatus,
            item.phaseBudget,
            item.developers?.map(t => t.employeeId?.employeeName).join("; ") || "--",
            item.milestones
            ]);
      
            const csvContent = [
              headers.join(","),
              ...csvRows.map((row) => row.join(",")),
            ].join("\n");
      
            downloadFile({
              data: csvContent,
              fileName: "phase-details.csv",
              fileType: "text/csv",
            });
          } catch (error) {
            if (error) {
              setDownloadLoader(false);
            }
          } finally {
            setDownloadLoader(false);
          }
        };

  function getWindowDimensions() {
      const { innerWidth: width, innerHeight: height } = window;
      return { width, height };
    }
  
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

      const handleSubmit = () => {
        setDisabled(true);
        setTimeout(() => {
          setDisabled(false);
        }, 4000);
      
        const payload = {
          ...(isEdit && { id: phaseDetails._id }),
          projectId: phaseDetails.projectId,
          phase: phaseDetails.phase,
           startDate: phaseDetails.startDate
  ? dayjs(phaseDetails.startDate).format("YYYY-MM-DD")
  : null,
endDate: phaseDetails.endDate
  ? dayjs(phaseDetails.endDate).format("YYYY-MM-DD")
  : null,
          developers: (employeeName || []).map((emp) => ({
            employeeId: emp.value,
          })),
          phaseBudget:phaseDetails.phaseBudget,
          phaseStatus: phaseDetails.phaseStatus || "--",
          milestones: phaseDetails.milestones,
          externalLink: (fields || []).map((f) => ({
            label: f.label,
            value: f.value,
          })),
          status: 1,
        };
      
        console.log("Payload sent:", payload);
      
        const endpoint = isEdit
          ? "/auth/employee/updatephase"
          : "/auth/employee/addphase";
      
        api
          .post(endpoint, payload)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch(phaseAction.loadPhaseDetails({
               limit: 10,
               page: 1,
               status: "BOTH",
             }));

              toast.success(
                isEdit
                  ? "phase updated successfully"
                  : "phase added successfully"
              );
            } else {
              toast.warning(response?.data?.msg || "");
            }
            setmodalVisible(false);
          })
          .catch((err) => {
            console.log("API Error:", err.response || err.message);
            setmodalVisible(false);
            const errorMsg =
              err?.response?.data?.message ||
              `An error occurred while ${
                isEdit ? "updating" : "adding"
              } the project`;
            toast.error(errorMsg, { containerId: "toast-1" });
          });
      };

      const handleEdit = (EditSheet) => {
        const phasecopy = EditSheet.editData;
        console.log(phasecopy, "pc");
      
        setIsEdit(true);
        const employeesForSelect =
          phasecopy.developers?.map(t => ({
            label: t.employeeId?.employeeName,
            value: t.employeeId?._id,
          })) || [];
      
          const externalLinks =
          phasecopy.externalLink?.map((link) => ({
            label: link.label || "",
            value: link.value || "",
          })) || [];
      
        setPhaseDetails({
          _id: phasecopy._id,
          projectId: phasecopy.projectId?._id || phasecopy.projectId,
          phase: phasecopy.phase,
          startDate: phasecopy.startDate ? dayjs(phasecopy.startDate) : null,
          endDate: phasecopy.endDate ? dayjs(phasecopy.endDate) : null,
          phaseBudget:phasecopy.phaseBudget,
          milestones:phasecopy.milestones,
          phaseStatus:phasecopy.phaseStatus,
          developers: phaseDetails.developers.map(empId => ({ employeeId: empId })),
          externalLink:externalLinks
        });
        setemployeeName(employeesForSelect);
        setmodalVisible(true);
      };

      const handleDelete = () => {
            setDisabled(true);
            setTimeout(() => {
              setDisabled(false);
            }, 4000);
            const payload = {
              id:phaseId,
            };
            api
              .post(`/auth/employee/deletephase`, payload)
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  dispatch(phaseAction.loadPhaseDetails());
                  toast.success("phase deleted successfully");
                } else {
                  toast.warning(response?.data?.msg || "");
                }
                setDeleteModalOpen(false);
                return response.data;
              })
              .catch((err) => {
                const errorMsg =
             err?.response?.data?.error||err?.response?.data?.message ||
                  "An error occurred while deleting the leave details";
                toast.error(errorMsg);
                  setDeleteModalOpen(false);
                return Promise.reject(err);
              });
          };

      const phaseOptions = [{label:"Phase 1",value:"Phase 1"},
        {label:"Phase 2",value:"Phase 2"},
        {label:"Phase 3",value:"Phase 3"},
        {label:"Phase 4",value:"Phase 4"},
        {label:"Phase 5",value:"Phase 5"},
        {label:"Phase 6",value:"Phase 6"},
        {label:"Phase 7",value:"Phase 7"},
    ]

    const columns = [
          {
            title: (
              <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
                S.No
              </span>
            ),
            dataIndex: "sno",
            width: 70,
            className: "poppins-txt-lg",
            sorter: (a, b) => a.sno - b.sno,
          },
          {
            title: <span className="poppins-txt">Action</span>,
            dataIndex: "action",
            width: 130,
            render: (_, record) => (
              <Space style={{ gap: "8px" }}>
                {/* Edit Button */}
                <Button
                  style={{
                    background: "#34c38f",
                    border: "none",
                    minWidth: 30,
                    height: 30,
                    padding: "2px 4px",
                    fontSize: "0.75rem",
                  }}
                  onClick={() => {
                    handleEdit(record);
                    setPhaseId(record._id);
                  }}
                >
                  <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
                </Button>
      
                {/* Delete Button */}
                <Button
                  style={{
                    background: "#f46a6a",
                    border: "none",
                    minWidth: 30,
                    height: 30,
                    padding: "2px 4px",
                    fontSize: "0.75rem",
                  }}
                  onClick={() => {
                    setDeleteModalOpen(true);
                    setPhaseId(record._id);
                  }}
                >
                  <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
                </Button>
              </Space>
            ),
          },
          {
            title: (
              <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
                Project Name
              </span>
            ),
            dataIndex: "projectId",
            width: 160,
            className: "poppins-txt-lg",
            sorter: (a, b) => a.projectId.localeCompare(b.projectId),
          },
          {
            title: "Phase",
            dataIndex: "phase",
            className: "poppins-txt-lg",
            sorter: (a, b) => a.phase.localeCompare(b.phase),
          },
          {
            title: "start Date",
            dataIndex: "startDate",
            className: "poppins-txt-lg",
            sorter: (a, b) => a.startDate.localeCompare(b.startDate),
          },
          {
            title: "end Date",
            dataIndex: "endDate",
            className: "poppins-txt-lg",
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
          },
          {
          title: "Developers",
          dataIndex: "developers",
          className: "poppins-txt-lg",
          render: (developers) => (
            <span>
              {developers && developers.length > 0
                ? developers.map(emp => emp.employeeId?.employeeName).join(", ")
                : "--"}
            </span>
          ),
          },
          {
            title: "phase Budget",
            dataIndex: "phaseBudget",
            className: "poppins-txt-lg",
            sorter: (a, b) => a.phaseBudget.localeCompare(b.phaseBudget),
          },
          {
            title: "phase Status",
            dataIndex: "phaseStatus",
            className: "poppins-txt-lg",
            sorter: (a, b) => a.phaseStatus.localeCompare(b.phaseStatus),
          },
          {
            title: "Milestones",
            dataIndex: "milestones",
            className: "poppins-txt-lg",
            sorter: (a, b) => a.milestones.localeCompare(b.milestones),
          },
          ];

    return(
    <React.Fragment>
     <div className="pl-5">
             <MetaTags>
               <title>Phase | Mequals</title>
             </MetaTags>
           </div>

           <Row justify="space-between" className="mr-4">
                   <Col>
                     <BreadcrumbComponent title="Phase" items={BCrumb} />
                   </Col>
           
                   <Col>
                     <Button
                       className="custom-btn mt-2"
                       type="primary"
                       size="middle"
                       onClick={() => showModalOpen()}
                     >
                       Create Phase
                     </Button>
                   </Col>
                 </Row>

                 <Modal
                  open={modalVisible}
                  onCancel={handleModalClose}
                  title={
                  <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "20px",
                  }}
                  className="poppins-txt"
                  >
                  <span>{isEdit ? "Edit Phase" : "Create Phase"}</span>
                  </div>
                  }
                  className="poppins-txt custom-active-modal"
                  centered
                  maskClosable={false}
                  footer={true}
                  width="75vw"
                  height="590px"
                  maxWidth="1200px"
                  style={{
                  padding: 0,
                  marginLeft: windowDimensions.width > 992 ? "220px" : "0",
                  }}
                  >
                  <div
                  className="custom-modal-content"
                  style={{
                  height: "480px",
                  overflowY: "auto",
                  }}
                  >
                  <Row gutter={[16,16]}>
                   <Col xs={24} sm={24} md={12} xl={8} xxl={8} >
                   <div className="mb-2">
                  <Typography className="poppins-txt" style={{fontSize:16}} >Project Id<span style={{color:"red", marginLeft:"2px"}} >*</span></Typography>
                  </div>
                  <Select
                  allowClear
                  className="custom-select"
                  options={projectOptions}
                  value={phaseDetails.projectId}
                  placeholder="Select the project Name"
                  onChange={(value, option) => {
                  console.log("Selected:", value, option);
                  setPhaseDetails((prev) => ({
                    ...prev,
                    projectId: value,
                  }));
                  }}

                  ></Select>
                   </Col>

                  <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                  <div className="mb-2">
                    <Typography className="poppins-txt" style={{ fontSize: 16 }}>
                      Phase <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                    </Typography>
                  </div>
                  <Select
                    allowClear
                    value={phaseDetails.phase}
                    onChange={(value) =>
                    setPhaseDetails(prev => ({ ...prev, phase: value }))
                    }
                    options={phaseOptions}
                    className="custom-select"
                    placeholder="Select the Phase"
                  />
                  </Col>


                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <div className="mb-2">
                <Typography className="poppins-txt" style={{fontSize:16}}>Start Date
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
                </div>
                <DatePicker className="custom-select py-2"
                value={phaseDetails.startDate ? moment(phaseDetails.startDate) : null}
                onChange={(date) =>
                setPhaseDetails(prev => ({ ...prev, startDate: date }))
                }
                 format="DD/MM/YYYY"
                 />
                </Col>
        
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <div className="mb-2">
                <Typography className="poppins-txt" style={{fontSize:16}}>End Date
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
                </div>
                <DatePicker className="custom-select py-2" name="fromDate"
                value={phaseDetails.endDate ? moment(phaseDetails.endDate) : null}
                onChange={(date) =>
                setPhaseDetails(prev => ({ ...prev, endDate: date }))
                }
                 format="DD/MM/YYYY"
                 />
                </Col>

                <Col xs={24} sm={24} md={12} xl={8} xxl={8} >
              <div className="mb-2">
              <Typography className="poppins-txt">
              Milestones<span style={{color:"red",marginLeft:"2px"}}>*</span>
              </Typography>
              </div>
              <Input 
              placeholder="Milestones"
              value={phaseDetails.milestones}
              name="milestones"
              onChange={(e) =>
              setPhaseDetails(prev => ({ ...prev, milestones: e.target.value }))
              }
              />
              </Col>


              <Col xs={24} sm={24} md={12} xl={8} xxl={8} >
              <div className="mb-2">
              <Typography className="poppins-txt">
              Phase Budget<span style={{color:"red",marginLeft:"2px"}}>*</span>
              </Typography>
              </div>
              <Input 
              placeholder="Enter the phase Budget"
              value={phaseDetails.phaseBudget}
              name="phaseBudget"
              onChange={(e)=>handleModalChange(e)}
              />
              </Col>
              <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt" style={{fontSize:16}}>Project Status
                  <span style={{color:"red",marginLeft:"2px"}} >*</span>
                </Typography>
                </div>
                <Select
                placeholder="select project status"
                allowClear
                className="custom-select"
                value={phaseDetails.phaseStatus}
                onChange={(value) =>
                setPhaseDetails((prev) => ({ ...prev, phaseStatus: value }))
                }
                options={updatedget.dropdownlist.projectStatusOptions}
                />
              </Col>

               <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                <div className="mb-2">
                  <Typography className="poppins-txt" style={{fontSize:16}}>Developers
                    <span style={{color:"red",marginLeft:"2px"}} >*</span>
                  </Typography>
                  </div>
                  <Select
                  mode="multiple"
                  placeholder="select dev"
                  allowClear
                  className="custom-select"
                  value={employeeName.map(emp => emp.value)}
                   onChange={(values) => {
                  const selectedOptions = employeeOption.filter((opt) =>
                    values.includes(opt.value)
                  );
                  setemployeeName(selectedOptions);
                  }}
                  options={employeeOption}
                  />
                </Col>
              </Row>

            <Row className="mt-3">
              <Col xs={24} sm={24} md={12} xl={8} xxl={8} >
              <div >
              <div className="flex items-center space-x-2">
              <Typography className="poppins-txt" style={{ fontSize:16,  display: "block"}}>External Link</Typography>
              <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              <Button
              type="dashed"
              shape="circle"
              icon={<PlusCircleOutlined />}
              onClick={handleAddField}
              style={{ marginBottom: "12px" }}
              />
            </div>
            {fields.map((field, index) => (
              <Row gutter={12} key={index} style={{ marginBottom: "8px" }}>
                <Col span={10}>
                <Input
                placeholder="Label"
                value={field.label}
                onChange={(e) => handleChange(index, "label", e)}
                />
                </Col>
                <Col span={10}>
                <Input
                placeholder="Value"
                value={field.value}
                onChange={(e) => handleChange(index, "value", e)}
                />
                </Col>
                <Col span={2}>
                <Button
                type="text"
                danger
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={() => handleRemoveField(index)}
                />
                </Col>
                </Row>
              ))}
              </div>
              </Col>
            </Row>
             </div>
             <div
             className="custom-modal-footer"
             style={{
             borderTop: "1px solid #ccc",
             padding: "10px 16px",
             display: "flex",
             justifyContent: "flex-end",
             }}
             >
             <Button
             className="custom-btn"
             onClick={handleModalClose}
             style={{
             backgroundColor: "#f46a6a",
             color: "#fff",
             border: "none",
             marginRight: "10px",
             }}
             >
             Cancel
             </Button>
             <Button
             disabled={disabled}
             className="custom-btn"
             style={{
             backgroundColor: "#34c38f",
             color: "#fff",
             border: "none",
             }}
             // onClick={() => setIsConfirmVisible(true)}
             onClick={handleSubmit}
             >
             {isEdit ? "Update" : "Submit"}
             </Button>
             </div>
             </Modal>
            <div>
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: 16 }}
            >
            <Col>
           <Input
             placeholder="Search..."
             allowClear
             style={{ width: 250, fontFamily: "Poppins" }}
             name="searchInput"
             value={searchInput}
             onChange={(e) => setSearchInput(e.target.value)}
             type="text"
             autoComplete="off"
           />
           <Button
             icon={<SearchOutlined />}
             type="primary"
             style={{ marginLeft: 8 }}
             onClick={handleSearch}
           />
          </Col>
          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
          </Row>

          <Modal
                      title={"Confirmation"}
                      open={deleteModalOpen}
                      onCancel={handleDeleteModalCancel}
                      cancelText="Cancel"
                      className="poppins-txt custom-active-modal"
                      width={450}
                      footer={null}
                      // style={{ padding: 0 }}
                      centered
                      >
                      <div className="custom-modal-content">
                        <p>Are you sure you want to delete this project?</p>
                      </div>
              
                      <div
                        className="custom-modal-footer"
                        style={{
                          borderTop: "1px solid #ccc",
                          padding: "10px 16px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          className="custom-btn"
                          style={{
                            backgroundColor: "#f46a6a",
                            color: "#fff",
                            border: "none",
                            marginRight: "10px",
                          }}
                          onClick={() => handleDeleteModalCancel()}
                        >
                          Close
                        </Button>
                        <Button
                          disabled={disabled}
                          className="custom-btn"
                          onClick={() => handleDelete()}
                          style={{
                            backgroundColor: "#34c38f",
                            color: "#fff",
                            border: "none",
                          }}
                        >
                          Confirm
                        </Button>
                      </div>
                      </Modal>

                          <Table
                          columns={columns}
                          loading={searchLoading}
                          dataSource={tableData} 
                          rowKey={(record) => record._id}
                          rowClassName={"text-[12px]"}
                          pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          total: totalCount,
                          showSizeChanger: true,
                          pageSizeOptions: ["5", "10", "20", "50"],
                          showTotal: (total) => `Total ${total} projects`,
                          }}
                          sortDirections={["ascend", "descend"]}
                          showSorterTooltip={"sorter-icon"}
                          scroll={{ x: 765 }}
                          onChange={(pagination, filters, sorter) => {
                            const { current, pageSize } = pagination;
                        
                            setCurrentPage(current);
                            setPageSize(pageSize);
                            const updatedParams = {
                              ...searchValue,
                              page: current,
                              limit: pageSize,
                              status: "BOTH",
                            };
                            specificDispatch(phaseAction.loadPhaseDetails(updatedParams));
                          }}
                        />
              </div>
    </React.Fragment>
    )
}

export default Phase;